import { MailValidationSigningHistoryDTO } from 'src/app/shared/interfaces';

export class HistoryValidationSignature {
  id: number;
  fichierId: number;
  date: string;
  description: string;
  message: string;
  fromServiceId: number;
  toServiceId: number;
  fromContactId: number;
  fromService?: string;
  toService?: string;
  contactName?: string;
  typeEntrantSortant?: string;

  constructor(data?: MailValidationSigningHistoryDTO) {
    Object.assign(this, data);
  }
}
